module.exports = __webpack_public_path__ + "img/four.cc6f2c4e.svg";